import { 
    DAY_IN_MILLIS, 
    getDatePartsByMillis, 
    getToday, 
    getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
import { TAB_DATA_VALUES } from "../../../utils/constants";

const SIX_MONTHS = DAY_IN_MILLIS*30*6;
export const DATE_PERIOD_FILTERS = {
    GENERAL: {
        min: getToday(),
        max: [3000, 1, 1]
    },
    PAST: {
        min: getDatePartsByMillis(getTodayWithoutHourInMillis() - SIX_MONTHS),
        max: getDatePartsByMillis(getTodayWithoutHourInMillis() - DAY_IN_MILLIS)
    },
    DRAFT: {
        min: getDatePartsByMillis(getTodayWithoutHourInMillis() - SIX_MONTHS),
        max: [3000, 1, 1]
    },
    CANCELED: {
        min: getDatePartsByMillis(getTodayWithoutHourInMillis() - SIX_MONTHS),
        max: [3000, 1, 1]
    },
    UNPROCESSED: {
        min: getToday(),
        max: [3000, 1, 1]
    }
};
export const getDatePeriodFilters = isTeacherUser => {
    if (isTeacherUser) 
        return {
            [TAB_DATA_VALUES.TEACHER.GENERAL]: DATE_PERIOD_FILTERS.GENERAL,
            [TAB_DATA_VALUES.TEACHER.PAST]: DATE_PERIOD_FILTERS.PAST,
            [TAB_DATA_VALUES.TEACHER.CANCELED]: DATE_PERIOD_FILTERS.CANCELED
        };
    return {
        [TAB_DATA_VALUES.ADMIN.GENERAL]: DATE_PERIOD_FILTERS.GENERAL,
        [TAB_DATA_VALUES.ADMIN.PAST]: DATE_PERIOD_FILTERS.PAST,
        [TAB_DATA_VALUES.ADMIN.DRAFT]: DATE_PERIOD_FILTERS.DRAFT,
        [TAB_DATA_VALUES.ADMIN.CANCELED]: DATE_PERIOD_FILTERS.CANCELED,
        [TAB_DATA_VALUES.ADMIN.UNPROCESSED]: DATE_PERIOD_FILTERS.UNPROCESSED
    };
};
export const INIT_FILTER_FIELDS = {
    title: "", 
    organizerId: 0,
    date: -1
};